/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { HeaderDetails } from '~/campaign/types';
import { LinkedInAnnotation, PostComment, RpcPostContent } from '~/post/types';
import Card from '../Card';
import CardHeader from '../CardHeader';
import RenderPostMetaBar from '../Post/RenderPostMetaBar';
import UpdateContent from '../UpdateContent';

const postContentStyle = {
  padding: '1rem',
};

type DraftProps = {
  postId: string;
  basic?: boolean;
  updateType?: string;
  geolocationName?: string;
  postContent: RpcPostContent;
  profileService: string;
  children?: React.ReactNode;
  headerDetails: HeaderDetails;
  annotations?: LinkedInAnnotation[];
  comments?: PostComment[];
  channelData: {
    googlebusiness: {
      cta: string;
      link: string;
      title: string;
      start_date: number;
      end_date: number;
      start_time: string;
      end_time: string;
      code: string;
      terms: string;
    };
    instagram: {
      share_to_feed: boolean;
    };
    startPage?: {
      link: string;
    };
  };
};

const Draft = ({
  postId,
  updateType,
  basic,
  geolocationName,
  postContent,
  profileService,
  headerDetails,
  children,
  channelData,
  annotations,
  comments,
}: DraftProps): JSX.Element => (
  <Card>
    <CardHeader
      postId={postId}
      headerDetails={{
        channel: headerDetails.channel,
        creatorName: headerDetails.creatorName,
        avatarUrl: headerDetails.avatarUrl,
        createdAt: headerDetails.createdAt,
      }}
      comments={comments}
      isDraft
    />
    {/* Draft Content */}
    <div style={postContentStyle}>
      <UpdateContent
        {...postContent}
        profileService={profileService}
        basic={basic}
        channelData={channelData}
        annotations={annotations}
      />
    </div>
    <RenderPostMetaBar
      profileService={profileService}
      locationName={geolocationName}
    />
    {children}
  </Card>
);

Draft.defaultProps = {
  basic: false,
  geolocationName: null,
  children: null,
  annotations: [],
};

export default Draft;
